import {ConnectedComponent} from 'lowkey-component';

import {
  ViewportObserver,
  ViewportObserverEventType,
} from '@services/ViewportObserver';
import {appSelectors} from '@store/appSlice';

export class ViewportAnimation extends ConnectedComponent<HTMLDivElement> {
  _viewportObserver: ViewportObserver;

  constructor(element: HTMLDivElement) {
    super(element);

    this.onChange = this.onChange.bind(this);

    this._viewportObserver = new ViewportObserver({
      margin: '0%',
      ratio: 0.01,
    });
  }

  didMount() {
    // アンカーでの遷移ですでにスクロールされた状態に対応
    // setTimeout(() => {
    const {top = 0} = this.element?.getBoundingClientRect() || {};
    const windowScrollY = window.scrollY || window.pageYOffset;
    const y = top + windowScrollY;
    const isOver = windowScrollY + window.innerHeight > y;

    if (isOver) {
      // this.element?.classList.add('viewed')
      // this._viewportObserver.onChange.disconnectAll();
    }
    if (isOver) {
      this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
        if (status === 'hidingAnimation') {
          this.element?.classList.add('viewed');
        }
      });
      this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
        if (status === 'hidingAnimation') {
          this.element?.classList.add('viewed');
        }
      });
    }
    this._viewportObserver.observe(this.element);
    // }, 100) // msecまたないとwindow.pageYOffsetが0

    this._viewportObserver.onChange.connect(this.onChange);
  }

  onChange(type: ViewportObserverEventType) {
    if (type === 'below') {
      this.element?.classList.add('viewed');
      // this._viewportObserver.onChange.disconnectAll();
    } else if (type === 'below-pre') {
      this.element?.classList.remove('viewed');
    }
  }

  didUnmount() {
    this._viewportObserver.onChange.disconnect(this.onChange);
    this._viewportObserver.disconnect();
  }
}
